module.exports = "https://cdn.hellotech.com/client-assets/hubs_and_speakers_tablet_62611febb858e38aebf2ce1e00e7c5e4.png";